import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0deb64ef")
const _hoisted_1 = {
  key: 0,
  class: "_loadPrompt"
}
const _hoisted_2 = {
  key: 1,
  class: "_loadPrompt"
}
const _hoisted_3 = { class: "_header" }
const _hoisted_4 = { class: "_headerBack" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Error ", -1)
const _hoisted_6 = { class: "_main" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Whoops!", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" A game with the provided id does not exist. ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_11 = { class: "_header" }
const _hoisted_12 = { class: "_headerBack" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Error ", -1)
const _hoisted_14 = { class: "_main" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h2", null, "Sneaky!", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" You must purchase a game to create lobbies. ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "_header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " ... ")
], -1)
const _hoisted_20 = { class: "centralSpinner" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.checkingOwnership)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadSpinner, { text: "Checking ownership" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checkingOwnership && _ctx.isOwner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_LoadSpinner, { text: "Verified, creating lobby" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checkingGameExists && !_ctx.game.id)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_IconButton, {
                icon: "back",
                white: true,
                onClick: _ctx.navToBrowse
              }, null, 8, ["onClick"])
            ]),
            _hoisted_5
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _hoisted_10,
            _createVNode(_component_IconButton, {
              text: "Back to safety",
              icon: "back",
              onClick: _ctx.navToBrowse
            }, null, 8, ["onClick"])
          ])
        ], 64))
      : (!_ctx.checkingGameExists && _ctx.game.id && !_ctx.checkingOwnership && !_ctx.isOwner)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_IconButton, {
                  icon: "back",
                  white: true,
                  onClick: _ctx.navToBrowse
                }, null, 8, ["onClick"])
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _createVNode(_component_IconButton, {
                text: "View game in store",
                icon: "back",
                onClick: _ctx.navToGame
              }, null, 8, ["onClick"])
            ])
          ], 64))
        : _createCommentVNode("", true),
    (_ctx.checkingGameExists || _ctx.checkingOwnership)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_MovingIcon, {
              name: "loader_spinner",
              autoplay: true,
              loop: true
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}